import { render } from "./DrawerChat.vue?vue&type=template&id=9309b844&ts=true"
import script from "./DrawerChat.vue?vue&type=script&lang=ts"
export * from "./DrawerChat.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Devlop\\C-Zone-v1\\UI_EICPartnership\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__